import React from "react";

const PersistIfValiditionOrFilterFailDocs = <>
    <p>
        By default, if a setup fails, either because of validation or because a setup filter fails, the tradePlan will
        terminate.
        This attribute will tell the system to hang in limbo, so that you can hit the enter now button if your ok with
        entering
        even though validation failed.
        <p>
            An example of a failed validation would be if you try to trade the break of the
            previous daily high (with the candle trigger setup), but the price is already above the previous day high.
        </p>
        <p>
            An example of a failed setup filter would be if you utilize full time fame continuity, and one of the
            periods you have selected are not green (if long) or red (if short).
        </p>
        <p>
            Instead of terminating the trade plan, it will hang in limbo, and you can manually either enter now, or
            cancel, as you'd like.
        </p>
    </p>
</>
export default PersistIfValiditionOrFilterFailDocs